
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M54.24 48.915L31.243 9.262c-.36-.617-1.38-.617-1.73 0L6.518 48.915a.985.985 0 000 .996c.18.309.51.498.87.498H53.37c.36 0 .69-.19.87-.498a.986.986 0 000-.996zm-45.123-.497L30.374 11.75 51.63 48.418H9.117z"}}),_c('path',{attrs:{"d":"M30.384 35.734a1 1 0 01-1-.995V24.434a1 1 0 012 0V34.74a1 1 0 01-1 .995zM30.384 44.107a1 1 0 01-1-.996v-2.678a1 1 0 012 0v2.678c0 .558-.45.996-1 .996z"}})])
          )
        }
      }
    